module.exports = "<div class=admin-hotel-list><div kt-admin-hotel-search></div><ui-view></ui-view></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/admin-hotel-list/admin-hotel-list.html
// module id = 594
// module chunks = 0